import styles from './Fieldset.module.scss';
import { type ReactNode } from 'react';

interface Props {
  end?: ReactNode;
  children: ReactNode;
  legend: string;
}

export function Fieldset({ children, end, legend }: Props) {
  return (
    <fieldset className={styles['fieldset']}>
      <div className={styles['legend']}>
        <legend>{legend}</legend>
        {end && <div>{end}</div>}
      </div>
      <div className={styles['content']}>{children}</div>
    </fieldset>
  );
}
